var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      staticClass: "view-container",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "130px",
        width: "800px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      [
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u(
              [
                _vm.isEdit
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.showLog },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseSupplierShop.dataForm.titleBtn"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          [
            _vm._v(
              _vm._s(_vm.$t("BusinessPurchaseSupplierShop.dataForm.title")) +
                " "
            ),
          ]
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplierShop.dataForm.supplier"
                      ),
                      prop: "supplierId",
                    },
                  },
                  [
                    _c("BjSelectSupplier", {
                      attrs: {
                        "default-options": {
                          label: _vm.form.supplierName,
                          value: _vm.form.supplierId,
                        },
                        disabled: _vm.isEdit,
                      },
                      model: {
                        value: _vm.form.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supplierId", $$v)
                        },
                        expression: "form.supplierId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplierShop.dataForm.week"
                      ),
                      prop: "deliveryCycleDay",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-center" },
                      [
                        _c("el-input-number", {
                          staticClass: "full-width",
                          attrs: {
                            min: 0,
                            label: _vm.$t(
                              "BusinessPurchaseSupplierShop.dataForm.week"
                            ),
                            controls: false,
                          },
                          model: {
                            value: _vm.form.deliveryCycleDay,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "deliveryCycleDay", $$v)
                            },
                            expression: "form.deliveryCycleDay",
                          },
                        }),
                        _c("span", { staticClass: "ml5" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "BusinessPurchaseSupplierShop.dataForm.day"
                              )
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c("BjFormItemCode", {
              attrs: {
                label: _vm.$t(
                  "BusinessPurchaseSupplierShop.dataForm.supplierSpuCode"
                ),
                prop: "supplierSpuCode",
              },
              model: {
                value: _vm.form.supplierSpuCode,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "supplierSpuCode", $$v)
                },
                expression: "form.supplierSpuCode",
              },
            }),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c("BjFormItemCode", {
              attrs: {
                label: _vm.$t(
                  "BusinessPurchaseSupplierShop.dataForm.supplierSkuCode"
                ),
                prop: "supplierSkuCode",
              },
              model: {
                value: _vm.form.supplierSkuCode,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "supplierSkuCode", $$v)
                },
                expression: "form.supplierSkuCode",
              },
            }),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplierShop.dataForm.taxUnitPrice"
                  ),
                  prop: "taxUnitPrice",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "full-width",
                  attrs: {
                    min: 0,
                    label: _vm.$t(
                      "BusinessPurchaseSupplierShop.dataForm.taxUnitPrice"
                    ),
                    controls: false,
                  },
                  model: {
                    value: _vm.form.taxUnitPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "taxUnitPrice", $$v)
                    },
                    expression: "form.taxUnitPrice",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplierShop.dataForm.unitPrice"
                  ),
                  prop: "unitPrice",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "full-width",
                  attrs: {
                    min: 0,
                    label: _vm.$t(
                      "BusinessPurchaseSupplierShop.dataForm.unitPrice"
                    ),
                    controls: false,
                  },
                  model: {
                    value: _vm.form.unitPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "unitPrice", $$v)
                    },
                    expression: "form.unitPrice",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplierShop.dataForm.taxRate"
                  ),
                  prop: "taxRate",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex-center" },
                  [
                    _c("el-input-number", {
                      staticClass: "full-width",
                      attrs: {
                        min: 0,
                        label: _vm.$t(
                          "BusinessPurchaseSupplierShop.dataForm.taxRate"
                        ),
                        controls: false,
                      },
                      model: {
                        value: _vm.form.taxRate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taxRate", $$v)
                        },
                        expression: "form.taxRate",
                      },
                    }),
                    _c("span", { staticClass: "ml5" }, [_vm._v("%")]),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplierShop.dataForm.minQty"),
                  prop: "minQty",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "full-width",
                  attrs: {
                    min: 0,
                    label: _vm.$t(
                      "BusinessPurchaseSupplierShop.dataForm.minQty"
                    ),
                    precision: 0,
                    controls: false,
                    "controls-position": "right",
                  },
                  model: {
                    value: _vm.form.minQty,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "minQty", $$v)
                    },
                    expression: "form.minQty",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplierShop.dataForm.package"
                  ),
                  prop: "packagingFlag",
                },
              },
              [
                _c("BjSelectLov", {
                  attrs: { "option-list": _vm.STATUS_YES_TRUE },
                  model: {
                    value: _vm.form.packagingFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "packagingFlag", $$v)
                    },
                    expression: "form.packagingFlag",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplierShop.dataForm.shipping"
                  ),
                  prop: "shippingFlag",
                },
              },
              [
                _c("BjSelectLov", {
                  attrs: { "option-list": _vm.STATUS_YES_TRUE },
                  model: {
                    value: _vm.form.shippingFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "shippingFlag", $$v)
                    },
                    expression: "form.shippingFlag",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 24 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplierShop.dataForm.remark"),
                  prop: "remark",
                },
              },
              [
                _c("BjTextarea", {
                  attrs: {
                    placeholder: _vm.$t(
                      "BusinessPurchaseSupplierShop.dataForm.remark"
                    ),
                  },
                  model: {
                    value: _vm.form.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "remark", $$v)
                    },
                    expression: "form.remark",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u([
              {
                key: "right",
                fn: function () {
                  return [
                    !_vm.isEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addGoodsDialog },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessPurchaseSupplierShop.dataForm.addCommodity"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "BusinessPurchaseSupplierShop.dataForm.productInformation"
                )
              ) + " "
            ),
          ]
        ),
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.isEdit ? _vm.form.skuVO : _vm.form.skuList,
              border: "",
              script: "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: _vm.$t("table.countText"),
                width: "60",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "materialMainImages",
                label: _vm.$t("BusinessPurchaseSupplierShop.dataForm.picture"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        { staticClass: "class=flex flex-center" },
                        [
                          _c("BjViewUrl", {
                            attrs: {
                              url: _vm.isEdit ? row.spuPic : row.imageUrl,
                              height: "80px",
                              preview: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "skuCode",
                label: _vm.$t("BusinessPurchaseSupplierShop.dataForm.sku"),
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "skuName",
                label: _vm.$t("BusinessPurchaseSupplierShop.dataForm.skuName"),
                align: "center",
              },
            }),
          ],
          1
        ),
        _c("BjDialogList", {
          ref: "dialogListSku",
          attrs: {
            width: "80%",
            config: _vm.$BjDialogListConfig.skuDefault(
              this.$t("BusinessPurchaseSupplierShop.dataForm.addCommodity"),
              {
                defaultQuery: { setFlag: 0, status: [3, 4, 5] },
              }
            ),
            multiple: "",
          },
          on: { confirm: _vm.onAddGoodsDialogConfirm },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }